"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Radio = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@material-ui/core");
var _styles = require("@material-ui/core/styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Componente primário de interação com o usuário
 */

const useStyles = (0, _styles.makeStyles)(theme => ({
  radio: {
    color: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: 'rgba(98, 76, 146, .08)'
    }
  }
}));
const Radio = _ref => {
  let {
    color,
    disabled
  } = _ref;
  const classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_core.Radio, {
    color: color,
    disabled: disabled,
    className: disabled ? null : classes.radio
  });
};
exports.Radio = Radio;
Radio.propTypes = {
  /**
   * Cor do botão
   */
  color: _propTypes.default.oneOf(['primary', 'secondary']),
  /**
   * Se `true` o campo é desabilitado
   */
  disabled: _propTypes.default.bool
};
Radio.defaultProps = {
  color: 'primary',
  disabled: false
};
var _default = exports.default = Radio;